import {
  Component,
  Input,
  OnInit,
  ElementRef,
  HostListener,
  ViewChild,
} from '@angular/core';
import { AuditRecord } from '../../models/audit';
import { UtilsService } from '../../services';

@Component({
    selector: 'app-audit-record',
    templateUrl: './audit-record.component.html',
    styleUrls: ['./audit-record.component.scss'],
    standalone: false
})
export class AuditRecordComponent implements OnInit {
  @ViewChild('infoBox') infoBox!: ElementRef;
  @Input() audit: AuditRecord = {
    updatedBy: '',
    updatedAt: '',
    createdBy: '',
    createdAt: '',
  };
  @Input() from: string = '';
  @Input() showAuditButton: boolean = false;
  isAuditShow: boolean = false;

  constructor(private utilsService: UtilsService, private eRef: ElementRef) {}

  ngOnInit(): void {}

  @HostListener('document:click', ['$event'])
  clickout(event: Event) {
    if (
      this.isAuditShow &&
      this.infoBox &&
      !this.infoBox.nativeElement.contains(event.target)
    ) {
      this.isAuditShow = false;
    }
  }

  fnGetDate(date: any) {
    return this.utilsService.fnConvertDate(date);
  }

  toggleShowAudit() {
    this.isAuditShow = !this.isAuditShow;
  }
}
